import { useQuery } from '@tanstack/react-query';
import { siteApi } from '../../services/api';

export const siteKeys = {
  all: ['sites'] as const,
  list: (orgId?: string) => ['sites', 'list', orgId] as const,
};

export function useSites(orgId?: string) {
  return useQuery({
    queryKey: siteKeys.list(orgId),
    queryFn: () => siteApi.getSites(orgId),
    enabled: !!orgId,
    staleTime: 60_000,
    select: (data) => (Array.isArray(data) ? data : []),
  });
}
